module.exports = __webpack_public_path__ + "static/media/AXISBANK.c1d3cd6d.txt";